import {useCheckoutStore} from "#sharedMarketplace/features/checkout/stores/checkoutStore";
import { defineStore } from 'pinia';

export const useNotificationsStore = defineStore(
  'notifications',
  () => {

    const { $event } = useNuxtApp();
    const checkoutStore = useCheckoutStore();
    const {formData} = storeToRefs(checkoutStore);
    const {clear: clearCheckout} = checkoutStore;

    const notifications = computed(() => {
      const results = {};

      if (formData.value.id) {
        results[formData.value.id] = {
          type: 'checkout',
          data: {
            psychologist: formData.value.psychologist,
          }
        }
      }

      return results
    });

    const count = computed(() => Object.keys(notifications.value).length);


    const read = (id: string) => {
      const notification = notifications.value[id];
      if (notification) {
        if (notification.type === 'checkout') {
          clearCheckout();
          $event('checkoutCleared');
        }
      }
    }

    const clearAll = () => {

    }

    return {
      notifications,
      count,

      read,
      clearAll,
    }
  },
)
